const professorsAgendaCEM = [
  {
    weekday: "domingo",
    weekdayIndex: 0,
    availableHours: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21"]
  },
  {
    weekday: "segunda",
    weekdayIndex: 1,
    availableHours: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21"]
  },
  {
    weekday: "terça",
    weekdayIndex: 2,
    availableHours: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21"]
  },
  {
    weekday: "quarta",
    weekdayIndex: 3,
    availableHours: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21"]
  },
  {
    weekday: "quinta",
    weekdayIndex: 4,
    availableHours: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21"]
  },
  {
    weekday: "sexta",
    weekdayIndex: 5,
    availableHours: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21"]
  },
  {
    weekday: "sabado",
    weekdayIndex: 6,
    availableHours: ["08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21"]
  }
];

export default professorsAgendaCEM;
